// Field definitions for each editable content area of the CLK Art website.
// Keys match ArtGalleryContent.key in blocks-backend.
export const CONTENT_SCHEMAS = [
  {
    key: "settings",
    label: "Site settings",
    description: "Contact details, the announcement bar and footer, shown on every page.",
    path: "/",
    groups: [
      {
        title: "Announcement bar",
        fields: [
          { key: "announcement", label: "Main message", type: "text" },
          { key: "announcementExtras", label: "More messages", type: "strings", hint: "Shown alongside the main message on wider screens" },
        ],
      },
      {
        title: "Contact",
        fields: [
          { key: "email", label: "Email", type: "text", hint: "Purchase requests and enquiries are sent here unless CLK_NOTIFY_EMAIL is set on the server" },
          { key: "phone", label: "Phone", type: "text", hint: "Leave blank to hide" },
          { key: "location", label: "Location", type: "text" },
          { key: "established", label: "Established", type: "text" },
          { key: "instagram", label: "Instagram URL", type: "text" },
          { key: "facebook", label: "Facebook URL", type: "text" },
        ],
      },
      {
        title: "Footer",
        fields: [
          { key: "footerBlurb", label: "Footer text", type: "textarea" },
          { key: "companyName", label: "Company name", type: "text" },
          {
            key: "promises",
            label: "Promise strip",
            type: "repeater",
            itemLabel: "Promise",
            fields: [{ key: "title", label: "Text" }],
            hint: "Icons are picked from the wording (delivery, home, frame, gift)",
          },
        ],
      },
    ],
  },
  {
    key: "home",
    label: "Homepage",
    path: "/",
    groups: [
      {
        title: "Hero",
        fields: [
          { key: "heroEyebrow", label: "Small heading", type: "text" },
          { key: "heroTitle", label: "Headline", type: "text" },
          { key: "heroTitleAccent", label: "Headline (second line, in italics)", type: "text" },
          { key: "heroText", label: "Intro", type: "textarea" },
          { key: "heroArtworkSlug", label: "Hero artwork", type: "artwork", hint: "Falls back to the newest artwork marked 'Homepage hero'" },
        ],
      },
      { title: "New works", fields: [{ key: "newWorksTitle", label: "Section title", type: "text" }] },
      {
        title: "Featured artist",
        fields: [
          { key: "featuredArtistSlug", label: "Artist", type: "artist" },
          { key: "featuredArtistText", label: "Text", type: "textarea" },
          { key: "featuredArtworkSlug", label: "Artwork to show", type: "artwork", hint: "Defaults to the artist's newest piece" },
        ],
      },
      {
        title: "Our story",
        fields: [
          { key: "storyTitle", label: "Title", type: "text" },
          { key: "storyTitleAccent", label: "Title (italic part)", type: "text" },
          { key: "storyHtml", label: "Text", type: "richtext" },
          { key: "storyImage", label: "Image", type: "image", hint: "Defaults to the first About page gallery image" },
          { key: "storyImageCaption", label: "Image caption", type: "text" },
          {
            key: "stats",
            label: "Figures",
            type: "repeater",
            itemLabel: "Figure",
            fields: [
              { key: "value", label: "Figure" },
              { key: "label", label: "Label" },
            ],
          },
        ],
      },
      {
        title: "Enquiry band",
        fields: [
          { key: "enquireTitle", label: "Title", type: "text" },
          { key: "enquireTitleAccent", label: "Title (italic part)", type: "text" },
          { key: "enquireText", label: "Text", type: "textarea" },
        ],
      },
    ],
  },
  {
    key: "about",
    label: "About",
    path: "/about",
    groups: [
      {
        title: "Content",
        fields: [
          { key: "title", label: "Page title", type: "text" },
          { key: "introHtml", label: "Introduction", type: "richtext" },
          { key: "bodyHtml", label: "More about us", type: "richtext" },
          { key: "gallery", label: "Gallery", type: "gallery" },
        ],
      },
    ],
  },
  {
    key: "services",
    label: "Services",
    path: "/services",
    groups: [
      {
        title: "Content",
        fields: [
          { key: "title", label: "Page title", type: "text" },
          { key: "intro", label: "Introduction", type: "textarea" },
          { key: "image", label: "Image", type: "image" },
          {
            key: "services",
            label: "Services",
            type: "repeater",
            itemLabel: "Service",
            fields: [
              { key: "title", label: "Name" },
              { key: "text", label: "Description", multiline: true },
            ],
          },
        ],
      },
    ],
  },
  {
    key: "artInSitu",
    label: "Art in situ",
    path: "/art-in-situ",
    groups: [
      {
        title: "Content",
        fields: [
          { key: "title", label: "Page title", type: "text" },
          { key: "intro", label: "Introduction", type: "textarea" },
          { key: "gallery", label: "Photos", type: "gallery", hint: "Captions are shown under each photo" },
        ],
      },
    ],
  },
  {
    key: "contact",
    label: "Contact",
    path: "/contact",
    groups: [
      {
        title: "Content",
        fields: [
          { key: "title", label: "Page title", type: "text" },
          { key: "intro", label: "Introduction", type: "textarea" },
          { key: "hours", label: "Opening / viewing hours", type: "text" },
        ],
      },
    ],
  },
  {
    key: "terms",
    label: "Terms & conditions",
    path: "/terms",
    groups: [
      {
        title: "Content",
        fields: [
          { key: "title", label: "Page title", type: "text" },
          { key: "bodyHtml", label: "Text", type: "richtext" },
        ],
      },
    ],
  },
  {
    key: "privacy",
    label: "Privacy policy",
    path: "/privacy",
    groups: [
      {
        title: "Content",
        fields: [
          { key: "title", label: "Page title", type: "text" },
          { key: "bodyHtml", label: "Text", type: "richtext" },
        ],
      },
    ],
  },
];
